export default "__VITE_ASSET__DdMXVUK$__"